<script lang="ts">
  import type { Snippet } from 'svelte'
  import { onDestroy, onMount, setContext } from 'svelte'
  import { get, writable } from 'svelte/store'
  import type { HTMLAttributes } from 'svelte/elements'
  import useBoundingRect from '../../hooks/html-elements.svelte'

  const element = useBoundingRect()
  type Props = HTMLAttributes<HTMLDivElement> & {
    children: Snippet
  }

  const { children, ...rest }: Props = $props()

  const opened = writable(false)
  const position = writable({ x: 0, y: 0 })

  setContext('context-menu', { opened, position })

  function handleContextMenu(e: MouseEvent) {
    const rect = element.ref?.getBoundingClientRect()
    if (
      rect
      && e.clientX >= rect.left
      && e.clientY >= rect.top
      && e.clientX <= rect.right
      && e.clientY <= rect.bottom
    ) {
      e.preventDefault()
      opened.set(true)
      position.set({ x: e.clientX, y: e.clientY })
    }
    else if (get(opened)) {
      opened.set(false)
    }
  }

  function handleClick() {
    opened.set(false)
  }

  onMount(() => {
    document.addEventListener('contextmenu', handleContextMenu)
    document.addEventListener('click', handleClick)
  })

  onDestroy(() => {
    document.removeEventListener('contextmenu', handleContextMenu)
    document.removeEventListener('click', handleClick)
    opened.set(false)
  })
</script>

<div
  bind:this={element.ref}
  {...rest}
>
  {@render children()}
</div>
